import { Box, Typography, Stack, Avatar } from '@mui/material';

import OliviaNunnAvatar from 'assets/img/funnel/olivia-nunn-collective-member.webp';

export default function Testimonial() {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignItems: 'center',
                gap: 3,
                width: '100%',
                bgcolor: 'cement.50',
                px: { xs: 3, md: 6 },
                py: { xs: 3, md: 4 },
                borderRadius: 3,
            }}>
            <Avatar
                src={OliviaNunnAvatar}
                alt="Olivia Nunn"
                sx={{
                    width: 64,
                    height: 64,
                    flexShrink: 0,
                    display: { xs: 'none', md: 'block' },
                }}
            />
            <Stack sx={{ width: '100%' }}>
                <Typography variant="h2" component="p" sx={{ mb: { xs: 2, md: 1 } }}>
                    &ldquo;I was able to earn $12,000 with Collective&apos;s referral program&rdquo;
                </Typography>
                <Box sx={{ display: { xs: 'flex', md: 'block' }, alignItems: 'center', gap: 2 }}>
                    <Avatar
                        src={OliviaNunnAvatar}
                        alt="Olivia Nunn"
                        sx={{
                            width: 64,
                            height: 64,
                            flexShrink: 0,
                            display: { xs: 'block', md: 'none' },
                        }}
                    />
                    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}>
                        <Typography variant="subtitle2">Olivia Nunn</Typography>
                        <Typography variant="subtitle2" sx={{ color: 'text.secondary', ml: { md: 1 } }}>
                            PR Agency
                        </Typography>
                    </Box>
                </Box>
            </Stack>
        </Box>
    );
}
